import {FETCH_ONE_TO_ONE} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_ONE_TO_ONE:
            return action.payload;
        default:
            return state;
    }
};